document.addEventListener('DOMContentLoaded', function() {
    var el = document.body;

    function pageScrolled() {
        if (!el.classList.contains('scrolled') && window.scrollY > 0) {
            el.classList.add('scrolled');
        } else if (window.scrollY === 0) {
            el.classList.remove('scrolled');
        }
    }

    window.addEventListener('scroll', function (e) {
        pageScrolled();
    });

    pageScrolled();
});

(function($) {
    $(document).ready(function() {
        objectFitImages();

        var select2s = Array.from(document.getElementsByClassName('select-select2'));
        if (select2s && select2s.length > 0) {
            select2s.forEach(select => {
                $(select).select2({
                    dropdownCssClass: $(select).closest('.big-form').length > 0 ? 'big-form-select2-dropdown' : '',
                });
            });
        }

        var galleries = Array.from(document.getElementsByClassName('light-gallery'));
        if (galleries && galleries.length > 0) {
            galleries.forEach(gallery => {
                lightGallery(gallery);
            });
        }

        var navbarContent = $('#navbar-content');
        if (navbarContent) {
            var htmlBody = $('html body');
            navbarContent.on('hide.bs.collapse', function () {
                htmlBody.removeClass('navbar-shown');
                navbarContent.addClass('hide');
            });
            navbarContent.on('show.bs.collapse', function () {
                htmlBody.addClass('navbar-shown');
                navbarContent.removeClass('hide');
            });
        }

        var slidersInitialized = false;
        function initSliders() {
            var slidersInitialized = true;
            var sliders = document.querySelectorAll('.slider-wrapper');
            if (sliders) {
                $(sliders).removeClass('is-hidden');
                sliders.forEach(sliderItem => {
                    var slider = $(sliderItem).find('.slider').first();
                    if (slider) {
                        slider.flickity({
                            cellSelector: '.slide',
                            prevNextButtons: false,
                            pageDots: false,
                            adaptiveHeight: false,
                            autoPlay: 5000,
                            pauseAutoPlayOnHover: true,
                            imagesLoaded: true,
                            groupCells: false,
                            wrapAround: true,
                        });

                    }
                });
            }
        }
        if (window.innerWidth < 768) {
            initSliders();
        }
        window.addEventListener('resize', function() {
            if (window.innerWidth < 768) {
                if (!slidersInitialized) {
                    initSliders();
                }
            } else {
                slidersInitialized = false;
                $('.slider-wrapper .slider.flickity-enabled').flickity('destroy');
            }
        })

    })
})(jQuery);
